/**
 * PotStatusBadge Atom
 * Displays pot status as a colored chip
 * Pattern: Atomic Design - Atoms, matches TableStatusChip styling
 */

import { Chip, statusChipColor, statusToken } from '@billda/design-system';
import { PotStatus } from '../types/pot.types';

export interface PotStatusBadgeProps {
  status: PotStatus;
}

/**
 * Compact status chip optimized for table rows
 * Matches TableStatusChip styling: 22px height, 11px font, outlined variant
 */
export function PotStatusBadge({ status }: PotStatusBadgeProps) {
  return (
    <Chip
      label={statusToken(status).word}
      color={statusChipColor(status)}
      variant="outlined"
      size="sm"
      className="h-[22px] px-1.5 text-[11px]"
    />
  );
}
